import React, { /* useContext, */ useState, useEffect, useRef } from "react";

import PopUpPanel from "../../PopUpPanel/PopUpPanel";

import { HexColorPicker } from "react-colorful";

import "./ColorPicker.scss";
import FormField from "../FormField/FormField";
// import { CampaignContext } from "../../../contexts/CampaignContext";
import { COLOUR_HEX_TO_COLOUR_NAME, COLOUR_NAME_TO_COLOUR_HEX, GET_COLOUR_INDEX_FROM_COLOUR_NAME, IS_COLOUR_NAME, UPDATE_RECENT_COLOURS } from "../../../helpers/Colours";
import { IconJsxer } from "../../../helpers/IconHelper";
import EditCampaignColoursPopUpContent from "./EditCampaignColoursPopUpContent";

const colorPickerPopUpRefs = {
    // Just a store for references to our instance of the pop up component
}
export const ShowColorPicker = (color, setFunc, campaignData = null, label = null, showTooltipFunc = null, hideTooltipFunc = null) => {
    if (colorPickerPopUpRefs.showColorPicker) {
        colorPickerPopUpRefs.showColorPicker(color, setFunc, campaignData, label);
        colorPickerPopUpRefs.showTooltipFunc = showTooltipFunc;
        colorPickerPopUpRefs.hideTooltipFunc = hideTooltipFunc;
    }
}

const ColorPickerPopUp = (props) => {
    // const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    const [busy, setBusy] = useState(false);

    const [currentVal, setCurrentVal] = useState('#9146FF');
    const setVal = (newVal, confirm = false) => {
            const colourVal = COLOUR_NAME_TO_COLOUR_HEX(newVal, campaignData);
            console.log('Confirm colour val: ', newVal, colourVal);
            const newValIsAColour = newVal === colourVal || newVal === colourVal.substring(1);
            if (newValIsAColour) {
                if (newVal.substring(0, 1) !== '#') {
                    newVal = '#' + newVal;
                }
                const foundColourName = COLOUR_HEX_TO_COLOUR_NAME(newVal, campaignData);
                if (foundColourName) {
                    // We have a colour name, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
                    setCurrentVal(foundColourName);
                } else {
                    // We have a hex value, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
                    setCurrentVal(newVal);
                }
            } else {
                // We are dealing with a colour name, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
                // When confirming (ie. field loses focus, so we stopped typing), we want to replace alternatives that we accept with the proper colour name
                setCurrentVal(confirm ? COLOUR_HEX_TO_COLOUR_NAME(colourVal, campaignData) : newVal);
            }
        }
    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    const [campaignData, setCampaignData] = useState(null);
    const [varLabel, setVarLabel] = useState(null);

    const setFunc_ref = useRef(null);
    const showColorPicker = (color, setFunc, campaignData, varLabel) => {
        setFunc_ref.current = setFunc;
        setCurrentVal(color);
        setColorPickerVisible(true);
        setCampaignData(campaignData);
        setVarLabel(varLabel);
    }
    colorPickerPopUpRefs.showColorPicker = showColorPicker;

    const confirmNewColor = (e = null) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (setFunc_ref.current) {
            // console.log('Submitting colour: ', currentVal);
            setFunc_ref.current(currentVal, true);
        }

        UPDATE_RECENT_COLOURS(COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignData), campaignData);
        closePanelFunc();
    }

    const [editMode, setEditMode] = useState(false);
    const [editingColourName, setEditingColourName] = useState(null);
    const [editingColourHex, setEditingColourHex] = useState(null);
    const [editingColourIndex, setEditingColourIndex] = useState(null);

    const enterEditMode = (colourName, colourHex, colourIndex) => {
        setEditMode(true);
        setEditingColourName(colourName);
        setEditingColourHex(colourHex);
        setEditingColourIndex(colourIndex);
    }

    const exitEditMode = () => {
        setEditMode(false);
        setBusy(false);
        setCurrentVal((val) => COLOUR_HEX_TO_COLOUR_NAME(val, campaignData) ? COLOUR_HEX_TO_COLOUR_NAME(val, campaignData) : val);
    }

    const handleEditModeClick = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (IS_COLOUR_NAME(currentVal) && GET_COLOUR_INDEX_FROM_COLOUR_NAME(currentVal) !== undefined) {
            const colourHex = COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignData);
            const colourIndex = GET_COLOUR_INDEX_FROM_COLOUR_NAME(currentVal);
            enterEditMode(currentVal, colourHex, colourIndex);
        } else {
            enterEditMode('PRIMARY', campaignData.colours[0], 0);
        }
    }

    const addNewColour = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        colorPickerPopUpRefs.hideTooltipFunc();
        enterEditMode('COLOR' + (campaignData.colours.length + 1), currentVal, campaignData.colours.length);
    }

    const closePanelFunc = () => {
        // Should send the update to a setFunc
        if (editMode) {
            setEditMode(false);
        } else {
            setColorPickerVisible(false);
        }
    }

    return (
        <>
            {colorPickerVisible &&
                <PopUpPanel /* showCloseBtn={!busy} */ closePanelFunc={closePanelFunc} className={`color-pop${editMode ? ' edit-mode' : ''}`} showCloseBtn={true} showHeader={false} showFooter={false} showOverlay={true} showPanel={true}>
                    <div className="form-holder co-popup-content">
                        {editMode &&
                            <EditCampaignColoursPopUpContent
                                campaignData={campaignData}
                                colourName={editingColourName}
                                colourHex={editingColourHex}
                                colourIndex={editingColourIndex}
                                busy={busy}
                                setBusy={setBusy}
                                exitEditMode={exitEditMode}
                                showTooltipFunc={colorPickerPopUpRefs.showTooltipFunc}
                                hideTooltipFunc={colorPickerPopUpRefs.hideTooltipFunc}
                            />
                        }
                        {!editMode &&
                            <div className="form-field-content-holder">
                                <div className="form-field-content">
                                    <h2>Choose Color</h2>
                                    <div className="fl-row">
                                        
                                        <div className="fl-column grow">
                                            {varLabel &&
                                                <div className="var-label">{varLabel}</div>
                                            }

                                            <div className="fl-row grow">
                                                <div className="grow"></div>
                                                <HexColorPicker color={COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignData)} onChange={setVal} />
                                                <div className="grow"></div>
                                            </div>
                                            <div className="fl-row">
                                                <div className="grow"></div>

                                                <div className="current-color" 
                                                    style={{ background: COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignData) }}
                                                    onMouseEnter={colorPickerPopUpRefs.showTooltipFunc && IS_COLOUR_NAME(currentVal) ? (e) => colorPickerPopUpRefs.showTooltipFunc(COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignData), e) : null}
                                                    onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                ></div>

                                                <FormField
                                                    id={"colourPicker"}
                                                    placeholder="#000000"
                                                    showLabel={false}
                                                    type="text"
                                                    maxLength={12}
                                                    setFunc={setVal}
                                                    confirmChangeFunc={(val) => setVal(val, true)}
                                                    value={currentVal}
                                                    showError={false}
                                                    className="c-hex-field"
                                                />

                                                <div className="grow"></div>
                                            </div>

                                            <div className="colour-swatch-container">
                                                <div className="colour-swatch-row">
                                                    <h5>Recent Colors</h5>
                                                    <div className="grow"></div>
                                                </div>
                                                <div className="colour-swatch-row">
                                                    {campaignData.recentColours.map((colour, index) => {
                                                        return (
                                                            <div key={index} className={`colour-swatch`} 
                                                                style={{ background: colour }} onClick={(e) => setVal(COLOUR_HEX_TO_COLOUR_NAME(colour, campaignData) ?? colour)}
                                                                onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc(`${COLOUR_HEX_TO_COLOUR_NAME(colour, campaignData) ? COLOUR_HEX_TO_COLOUR_NAME(colour, campaignData) + ': ' : ''}${colour}`, e) : null}
                                                                onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                            ></div>
                                                        )
                                                    })}
                                                </div>
                                            </div>

                                            <div className="colour-swatch-container campaign-colours">
                                                {IconJsxer.GetIcon(IconJsxer.ICONS.edit, IconJsxer.ICON_STYLES.campaignPanelTop, 'edit-icon', handleEditModeClick)}
                                                <div className="colour-swatch-row">
                                                    <h5>Campaign Colors</h5>
                                                    <div className="grow"></div>
                                                </div>
                                                <div className="colour-swatch-row">
                                                    <div className={`colour-swatch${currentVal?.toLowerCase() === 'primary' ? ' selected' : ''}`} 
                                                        style={{ background: campaignData.colours[0] }} onClick={(e) => setVal('PRIMARY')}
                                                        onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc('PRIMARY: ' + COLOUR_NAME_TO_COLOUR_HEX('PRIMARY', campaignData), e) : null}
                                                        onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                    ></div>
                                                    <div className={`colour-swatch${currentVal?.toLowerCase() === 'secondary' ? ' selected' : ''}`} 
                                                        style={{ background: campaignData.colours[1] }} onClick={(e) => setVal('SECONDARY')}
                                                        onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc('SECONDARY: ' + COLOUR_NAME_TO_COLOUR_HEX('SECONDARY', campaignData), e) : null}
                                                        onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                    ></div>
                                                    <div className={`colour-swatch${currentVal?.toLowerCase() === 'tertiary' ? ' selected' : ''}`} 
                                                        style={{ background: campaignData.colours[2] }} onClick={(e) => setVal('TERTIARY')}
                                                        onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc('TERTIARY: ' + COLOUR_NAME_TO_COLOUR_HEX('TERTIARY', campaignData), e) : null}
                                                        onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                    ></div>
                                                </div>
                                                <div className="colour-swatch-row">
                                                    {campaignData.colours.length > 3 && campaignData.colours.slice(3).map((colour, index) => {
                                                        return (
                                                            <div key={index} className={`colour-swatch${currentVal?.toLowerCase() === 'color' + (index + 4) ? ' selected' : ''}`} 
                                                                style={{ background: colour }} onClick={(e) => setVal('COLOR' + (index + 4))}
                                                                onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc('COLOR' + (index + 4) + ': ' + colour, e) : null}
                                                                onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                            ></div>
                                                        )
                                                    })}
                                                    {!IS_COLOUR_NAME(currentVal) && !busy &&
                                                        <div className={`add-btn`} 
                                                            onClick={addNewColour}
                                                            onMouseEnter={colorPickerPopUpRefs.showTooltipFunc ? (e) => colorPickerPopUpRefs.showTooltipFunc(`Save ${currentVal} To Campaign Colours`, e) : null}
                                                            onMouseLeave={colorPickerPopUpRefs.hideTooltipFunc}
                                                        >
                                                            {IconJsxer.GetIcon(IconJsxer.ICONS.plus, IconJsxer.ICON_STYLES.roundPanelButtonSmall)}
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <button className="standard-button" onClick={confirmNewColor}>Submit</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </PopUpPanel>
            }
        </>
    )
}

export default ColorPickerPopUp;
